export const unifiedPlatformColorPalette = {
  lightTextPrimary: '#2D2D2D',
  lightTextSecondary: '#616161',
  lightErrorDark: '#94001B',
  lightError: '#B00020',
  lightErrorLight: '#B0002030',
  lightErrorShades30p: '#B000204D',
  lightPrimary: '#246516',
  lightPrimaryDark: '#488527',
  lightPrimaryShades30p: '#6EAE3A4D',
  lightErrorShades4p: '#B000200A',
  lightPrimary900: '#246516',
  lightSuccess: '#7DBE42',
  inmarketGreen: '#7DBE42',
  lightSuccess50: '#7DBE4250',
  gray100: '#F5F5F5',
  lightGrey300: '#E0E0E0',
  lightGrey50: '#FAFAFA',
  lightBlue50: '#E1F5FE',
  lightSecondaryDark: '#3462B6',
  lightSecondaryLight: '#96B7F3',
  lightSecondary300: '#254682',
  lightGreen50: '#F1F8E9',
  green700: '#5B9A31',
  lightGreen600: '#7CB342',
  chartLightBlue: '#A6CEE3',
  chartLightGreen: '#B2DF8A',
  chartDarkGreen: '#33A02C',
  chartDarkBlue: '#1F78B4',
  chartLightRed: '#FFA559',
  chartDarkRed: '#CE4749',
  chartLightOrange: '#FDBF6F',
  chartDarkOrange: '#FF7F00',
  chartLightPurple: '#CAB2D6',
  chartDarkPurple: '#6A3D9A',
  chartLightYellow: '#FFFF99',
  chartDarkYellow: '#E6D856',
  lightBackgroundDefault: '#F6F6F6',
  lightBackground: '#F9F9F9',
  lightWarning: '#E68E00',
  lightActionActive: '#0000008A',
  lightBlue: '#437EEB',
  white: '#FFFFFF',
  black: '#000000',
};

export const chartColors = [
  unifiedPlatformColorPalette.chartLightBlue,
  unifiedPlatformColorPalette.chartLightGreen,
  unifiedPlatformColorPalette.chartDarkBlue,
  unifiedPlatformColorPalette.chartDarkGreen,
  unifiedPlatformColorPalette.chartLightRed,
  unifiedPlatformColorPalette.chartDarkRed,
  unifiedPlatformColorPalette.chartLightOrange,
  unifiedPlatformColorPalette.chartDarkOrange,
  unifiedPlatformColorPalette.chartLightPurple,
  unifiedPlatformColorPalette.chartDarkPurple,
  unifiedPlatformColorPalette.chartDarkYellow,
  unifiedPlatformColorPalette.chartLightYellow,
];
